import * as React from 'react';

import {RadioGroupSimple} from 'shells/radio-group-simple/radio-group-simple';

const FILTERING_OPTIONS = [
    {id: 'trash-filter-all', label: 'All'},
    {id: 'trash-filter-contacts', label: 'People'},
    {id: 'trash-filter-accounts', label: 'Companies'},
    {id: 'trash-filter-leads', label: 'Leads'},
    {id: 'trash-filter-tags', label: 'Tags'},
    {id: 'trash-filter-sources', label: 'Sources'},
    {id: 'trash-filter-products', label: 'Products'},
    {id: 'trash-filter-notes', label: 'Notes'},
    {id: 'trash-filter-territories', label: 'Territories'},
];

export type TrashFilterOption =
    | 'all'
    | 'contacts'
    | 'accounts'
    | 'leads'
    | 'tags'
    | 'sources'
    | 'products'
    | 'notes'
    | 'territories';

type Props = {
    selectedFilter: TrashFilterOption;
    onChange: (arg1: TrashFilterOption) => any;
};

export class TrashFilters extends React.Component<Props> {
    render() {
        return (
            <RadioGroupSimple
                name='recycle-bin-filters'
                options={FILTERING_OPTIONS}
                selectedOption={this.props.selectedFilter}
                onChange={this.handleChange}
            />
        );
    }

    handleChange = (id: string) => {
        // Dumb cast through `any` to type option correctly
        // TODO: better type refinement
        const option: TrashFilterOption = id.replace('trash-filter-', '') as any;
        this.props.onChange(option);
    };
}
